function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 31.999,
  cy: 32,
  r: 29.019,
  stroke: "#333",
  strokeWidth: 2.85
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.932 31.152l9.378 9.38 18.758-17.063",
  stroke: "#000",
  strokeWidth: 2.85,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIconCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMzEuOTk5MSIgY3k9IjMyIiByPSIyOS4wMTk0IiBzdHJva2U9IiMzMzMzMzMiIHN0cm9rZS13aWR0aD0iMi44NSIvPgo8cGF0aCBkPSJNMTcuOTMxNiAzMS4xNTI1TDI3LjMxMDQgNDAuNTMxM0w0Ni4wNjc4IDIzLjQ2ODgiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMi44NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgIconCheckCircle as ReactComponent };